<template>
  <div class='points-ladder'>
    <v-data-table
      :headers="[
        {text: '#', value: 'num', align: 'center'},
        {text: 'Name', value: 'name', align: 'left'},
        {text: 'Points', value: 'points', align: 'center'}
      ]"
      :items='results'
      sort-by='points'
      :sort-desc='true'
    >
      <template v-slot:item='{item}'>
        <tr :key='item.num' style='text-align: left' :class="{'winner': item.num <= 10, 'first': item.num === 1, 'second': item.num === 2, 'third': item.num === 3}">
          <td style='text-align: center'>{{item.num}}</td>
          <td>{{item.name}}</td>
          <td style='text-align: center'>{{item.points}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import RoundsService from '@/services/TPC/RoundsService'

export default {
  name: 'points-ladder',
  data () {
    return {
      results: [],
    }
  },
  props: {
    seasonID: Number,
    segmentID: Number,
    eventID: String,
  },
  async created () {
    const response = await RoundsService.getLeaderboard({eventID: this.eventID, seasonID: this.seasonID, segmentID: this.segmentID})
    if (response.data.error) {
      console.error(`Error: ${response.data.error} - ${response.data.message}`)
    }

    response.data.results.sort((a, b) => b.points - a.points)
    this.results = response.data.results.map((v, i) => ({num: i+1, ...v}))
  }
}
</script>

<style scoped>
tr.winner {
  background-color: rgba(0, 255, 0, 0.4);
}
tr.first {
  background-color: rgba(255, 213, 0, 0.835);
}
tr.second {
  background-color: rgba(172, 172, 172, 0.767);
}
tr.third {
  background-color: rgba(255, 115, 0, 0.794);
}
</style>
